import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { SfDataService } from '../../services/sf-data.service'; 
import { UserEdit } from '../../models/user-edit.model'; 
import { Subject } from 'rxjs';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
    selector: 'app-sf-icd-campaignparticipation',
    templateUrl: './sf-icd-campaignparticipation.component.html',
    styleUrls: ['./sf-icd-campaignparticipation.component.scss'],
    standalone: false
})
export class SfIcdCampaignparticipationComponent implements OnInit {


  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};

   
  public userEdit: UserEdit;
  @Input()
  isViewOnly: boolean;

  @Input()
  isGeneralEditor = false;

  lstdata: any = [];

  constructor(private alertService: AlertService, private sfDataService: SfDataService, private accountService: AccountService, private router: Router, private configurations: ConfigurationService) { }


  ngOnInit() {
    if (!this.canViewCustomers) {
      this.router.navigate(['/']);

    }
    if (!this.isGeneralEditor) {
      
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: this.configurations.defaultPageSize,
        lengthMenu: [10, 25, 50, 100],
        processing: true,
        ajax: (dataTablesParameters: any, callback) => {
          this.sfDataService.getCPReports().subscribe(resp => {


            this.lstdata = resp;
            this.lstdata = this.getDistinctColumnValues(resp, 'accountStatus'); 
            ////console.log(resp);
            callback({
              //recordsTotal: resp.recordsTotal,
              //recordsFiltered: resp.recordsFiltered,
              data: resp             // <-- see here
            });
            // this.alertService.showStickyMessage('Data loaded', '', MessageSeverity.info);
            $('.dt-buttons').addClass('pull-right');
          });
        },
        columns: [{
          title: 'ICD Company',
          data: 'accountName'
        }, {
          title: 'Owner name',
          data: 'accountOwnerName'
        }

          
          , {
          title: 'TAX ID',
          data: 'accountTaxID'
        }
          
          , {
          title: 'Distributor No',
            data: 'accountParentDistributorCode'
        }
          , {
          title: 'Campaign No',
          data: 'name'
        }
          , {
          title: 'Campaign Name',
            data: 'campaignName'
        }
          
          , {
          title: 'Start Date',
            data: 'startDate',
            render: (data: any, type: any, full: any) => {
              if (type === 'display' || type === 'filter') {
                // Format date for display and filtering
                return this.formatDate(data);
              }
              return data; // Return raw data for sorting and other types
            }
        },
          {
            title: 'End Date',
            data: 'endDate',
            render: (data: any, type: any, full: any) => {
              if (type === 'display' || type === 'filter') {
                // Format date for display and filtering
                return this.formatDate(data);
              }
              return data; // Return raw data for sorting and other types
            }
          },
           {
          title: 'ICD Status',
            data: 'accountStatus'
        }
          , {
            title: 'Hub Name',
            data: 'accountHubName'
          }

        ],
        // Declare the use of the extension in the dom parameter
        dom: 'lBfrtip',
        responsive: true,
        intiComplete: function (settings: any, json: any) {
          $('.dt-buttons').addClass('pull-right');
        },
        // Configure the buttons
        buttons: [
          //'columnsToggle',
          //'colvis',
          //'copy',
          //'print',
          { extend: 'excel', title: "CP", text: 'Export to Excel', className: 'btn btn-sm btn-success mb-2 pull-right' },
          //{
          //  text: 'Some button',
          //  key: '1',
          //  action: function (e, dt, node, config) {
          //    alert('Button activated');
          //  }
          //}
        ]
      };
    }
  }
  formatDate(dateString: string): string {
    if (dateString && typeof dateString === 'string') {
      const parts = dateString.split('-');
      ////console.log(parts);
      if (parts.length === 3) {
        const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
        return formattedDate;
      }
    }
    return dateString;
  }

  ngAfterViewInit(): void {
    
  }
   

  getDistinctColumnValues(data: any[], columnName: string): string[] {
    const columnValues = data.map(item => item[columnName]);
    return [...new Set(columnValues)];
  }

  get canViewCustomers() {
    return true;// this.accountService.userHasPermission(Permission.viewUsersPermission); // eg. viewCustomersPermission
  }

  filterTableByStatus(status: string) {
    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Update the search text in the "Request Status" column to filter by the clicked status
    if (status == null) {
      table.column(8).search('').draw();
    }
    else { table.column(8).search(status).draw(); }

  }
    

}
